// extracted by mini-css-extract-plugin
export default {"buttons":"buttons__RegionOverviewZoomButtons__YIzbD","button":"button__RegionOverviewZoomButtons__YIzbD"};